module.exports = __webpack_public_path__ + "img/Twitch.c47d7bf2.svg";